import { createRoute, redirect } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { siteRoute } from '../layouts';

const pages = () => import('./pages');
const optionsComp = lazyPage(pages, 'StorefrontOptionsHost');
const widgetsComp = lazyPage(pages, 'StorefrontWidgetsHost');

// /storefront redirects to the core widgets script page.
const storefrontIndexRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/core', params });
  },
});

const storefrontOptionsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/options',
  component: optionsComp,
  staticData: { title: 'storefront.options' },
});

// /storefront/widgets redirects to the core script page.
const storefrontWidgetsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/widgets',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/$siteEnv/storefront/widgets/core', params });
  },
});

const storefrontWidgetsCoreRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/widgets/core',
  component: widgetsComp,
  staticData: { title: 'storefront.widgets_core' },
});

const storefrontWidgetsPdpRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/widgets/pdp',
  component: widgetsComp,
  staticData: { title: 'storefront.widgets_pdp' },
});

const storefrontWidgetsCssRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/widgets/css',
  component: widgetsComp,
  staticData: { title: 'storefront.widgets_css' },
});

const storefrontWidgetsTipsRoute = createRoute({
  getParentRoute: () => siteRoute,
  path: 'storefront/widgets/tips',
  component: widgetsComp,
  staticData: { title: 'storefront.widgets_tips' },
});

/** Storefront family leaves to attach under the site-env layout. */
export const storefrontLeaves = [
  storefrontIndexRoute,
  storefrontOptionsRoute,
  storefrontWidgetsRoute,
  storefrontWidgetsCoreRoute,
  storefrontWidgetsPdpRoute,
  storefrontWidgetsCssRoute,
  storefrontWidgetsTipsRoute,
];
